import "./ProductPolicyTab.scss";
import Blank from "../common/Blank";

const ProductPolicyTab = ({ shipping_policy, return_exchange_policy }) => {
    // 반품/교환 정책 데이터가 없는 경우 처리
    if (!return_exchange_policy) {
        return (
            <div className="policy-tab-wrap">
                <div className="no-policy-message">
                    <p>교환/반품 정보가 없습니다.</p>
                </div>
            </div>
        );
    }

    const {
        label: returnLabel,
        carrier,
        address,
        responsibility_rules,
    } = return_exchange_policy;

    const {
        courier,
        base_fee,
        bundle_shipping,
        label: shippingLabel,
    } = shipping_policy;
    return (
        <div className="policy-tab-wrap">
            <div className="policy-section">
                <h3 className="policy-section-title">배송 정보</h3>
                <tbody className="policy-table">
                    <tr>
                        <th scope="row" className="policy-table-label">
                            택배사
                        </th>
                        <td colspan="3" className="policy-table-value">
                            {courier}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className="policy-table-label">
                            기본 배송비
                        </th>
                        <td colspan="3" className="policy-table-value">
                            {base_fee}원
                            <br />
                            {shippingLabel}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className="policy-table-label">
                            묶음배송
                        </th>
                        <td colspan="3" className="policy-table-value">
                            {bundle_shipping ? "가능" : "불가능"}
                        </td>
                    </tr>
                </tbody>
            </div>
            <div className="policy-section">
                <h3 className="policy-section-title">교환/반품 정보</h3>
                <tbody className="policy-table">
                    <tr>
                        <th scope="row" className="policy-table-label">
                            택배사
                        </th>
                        <td colspan="3" className="policy-table-value">
                            {carrier}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className="policy-table-label">
                            배송비
                        </th>
                        <td className="policy-table-value">{returnLabel}</td>
                    </tr>
                    <tr>
                        <th scope="row" className="policy-table-label">
                            보내실 곳
                        </th>
                        <td colspan="3" className="policy-table-value">
                            {address}
                        </td>
                    </tr>

                    <tr>
                        <th
                            scope="row"
                            rowspan="7"
                            className="policy-table-label"
                        >
                            반품/교환 불가 사유
                        </th>
                        <td colspan="3" className="policy-table-value">
                            <ol>
                                <li>
                                    주문/제작 상품의 경우, 상품의 제작이 이미
                                    진행된 경우
                                </li>
                                <li>
                                    상품 포장을 개봉하여 사용 또는 설치 완료되어
                                    상품의 가치가 훼손된 경우
                                </li>
                                <li>
                                    고객의 사용, 시간경과, 일부 소비에 의하여
                                    상품의 가치가 현저히 감소한 경우
                                </li>
                                <li>
                                    세트상품 일부 사용, 구성품을 분실하였거나
                                    취급 부주의로 인한 파손/고장/오염으로 재판매
                                    불가한 경우
                                </li>
                                <li>
                                    모니터 해상도의 차이로 인해 색상이나
                                    이미지가 실제와 달라, 고객이 단순 변심으로
                                    교환/반품을 무료로 요청하는 경우
                                </li>
                                <li>
                                    제조사의 사정 (신모델 출시 등) 및 부품 가격
                                    변동 등에 의해 무료 교환/반품으로 요청하는
                                    경우
                                </li>
                            </ol>
                        </td>
                    </tr>
                </tbody>
            </div>

            {/* 책임 규정 섹션 */}
            <div className="policy-section">
                <h3 className="policy-section-title">교환/반품 책임 규정</h3>
                <div className="responsibility-table">
                    <div className="responsibility-table-header">
                        <div className="responsibility-header-cell">구분</div>
                        <div className="responsibility-header-cell">책임자</div>
                        <div className="responsibility-header-cell">배송비</div>
                    </div>
                    {responsibility_rules &&
                        Object.entries(responsibility_rules).map(
                            ([reason, rule]) => (
                                <div
                                    key={reason}
                                    className="responsibility-table-row"
                                >
                                    <div className="responsibility-table-cell reason-cell">
                                        {reason}
                                    </div>
                                    <div className="responsibility-table-cell">
                                        {rule.책임자}
                                    </div>
                                    <div className="responsibility-table-cell">
                                        {rule.배송비}
                                    </div>
                                </div>
                            )
                        )}
                </div>
            </div>
            <Blank height={50} />
        </div>
    );
};

export default ProductPolicyTab;
